import { createSelector } from '@reduxjs/toolkit';

import { selectCommercialPriceTypeLabel } from './selectCommercialPriceTypeLabel';
import { selectCommercialPriceTypeOptions } from './selectCommercialPriceTypeOptions';
import { selectCommercialPriceTypeValue } from './selectCommercialPriceTypeValue';

export const selectCommercialPriceTypeFilter = createSelector(
  [selectCommercialPriceTypeLabel, selectCommercialPriceTypeValue, selectCommercialPriceTypeOptions],
  (label, value, options) => ({
    label,
    value,
    options,
  }),
);
